import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Renders nothing — just watches the current page's <section> blocks
// (and a couple of common card/grid patterns) and fades + slides each
// one up into place the first time it scrolls into view. Re-runs on
// every route change so newly-mounted pages get observed too.
export default function ScrollReveal() {
  const location = useLocation();

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const targets = Array.from(
      document.querySelectorAll(
        "main section, main .tp-reveal, main .tp-home-categories__card, main .tp-founder"
      )
    );

    if (prefersReducedMotion || targets.length === 0) {
      targets.forEach((el) => el.classList.add("tp-reveal-visible"));
      return;
    }

    targets.forEach((el, index) => {
      el.classList.add("tp-reveal-init");
      // Small stagger for elements that share a row (product/founder
      // cards) so they don't all pop in on the exact same frame.
      el.style.setProperty("--tp-reveal-delay", `${(index % 4) * 70}ms`);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("tp-reveal-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );

    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [location.pathname]);

  return null;
}
